import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { register } from "./serviceWorkerRegistration";

// Résilience www/apex: si la page est servie sur www.domaine.fr mais que
// REACT_APP_BACKEND_URL pointe sur domaine.fr (ou inversement), utiliser
// l'origine de la page pour éviter les redirections 308 qui cassent CORS.
(() => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  try {
    const envHost = new URL(envUrl).hostname;
    const pageHost = window.location.hostname;
    const sameRegistrable = envHost.replace(/^www\./, "") === pageHost.replace(/^www\./, "");
    window.__BACKEND_URL__ = sameRegistrable && envHost !== pageHost ? window.location.origin : envUrl;
  } catch (e) {
    window.__BACKEND_URL__ = envUrl;
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);

// Register PWA service worker
register();
